var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 17.6569C16.5584 18.6852 15.0128 19.306 13.3238 19.306C9.55511 19.306 6.5 16.2154 6.5 12.403C6.5 8.59057 9.55511 5.5 13.3238 5.5C15.0128 5.5 16.5584 6.12075 17.75 7.14903C18.9416 6.12075 20.4872 5.5 22.1762 5.5C25.9449 5.5 29 8.59057 29 12.403C29 16.2154 25.9449 19.306 22.1762 19.306C20.4872 19.306 18.9416 18.6852 17.75 17.6569Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 17.6569C19.2172 16.3908 20.1475 14.5068 20.1475 12.403C20.1475 10.2992 19.2172 8.41517 17.75 7.14903C18.9416 6.12075 20.4872 5.5 22.1762 5.5C25.9449 5.5 29 8.59057 29 12.403C29 16.2154 25.9449 19.306 22.1762 19.306C20.4872 19.306 18.9416 18.6852 17.75 17.6569Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7491 7.14893C19.2163 8.41506 20.1466 10.2991 20.1466 12.4029C20.1466 14.5067 19.2163 16.3906 17.7491 17.6568C16.2819 16.3906 15.3516 14.5067 15.3516 12.4029C15.3516 10.2991 16.2819 8.41506 17.7491 7.14893Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.9b38ae57efcd1ce8153111b12e832041.svg";
export { ForwardRef as ReactComponent };